import React from "react";
import './index.css'
import { color } from './../../utils/themes/color';
import LOADING from "../loading/loading";
import plus from './../../assets/images/plus.png';


export default function UPLOADVIDEO(props) {

    var label = "upload";
    if (props.label != null && props.label != undefined) {
        label = props.label;
    }

    console.log(label)

    return (
        <>
            {
                props.video != undefined ?
                    <div style={{ width: '100%', height: '100%' }}>
                        <label htmlFor={label}>
                            <div className="upload-back" style={{ background: color.primaryContainer, color: color.primary }}>
                                {
                                    props.loading != undefined && props.loading != false
                                        ? <LOADING type={"lg"} />
                                        : <video controls crossOrigin="anonymous" style={{ width: "100%", height: "100%" }} >
                                            <source src={props.video} type="video/mp4"></source>
                                        </video>
                                }
                            </div>
                        </label>
                        <input
                            accept={props.accept != undefined && props.accept != null ? props.accept : ""}
                            id={label}
                            type="file"
                            style={{ display: "none" }}
                            onChange={(e) => props.click(e.target.files[0])} />
                    </div>
                    :
                    <div style={{ width: '100%', height: '100%' }}>
                        <label htmlFor={label}>
                            <div className="upload-back" style={{ background: color.primaryContainer, color: color.primary }}>
                                {
                                    props.loading != undefined && props.loading != false
                                        ? <LOADING type={"lg"} />
                                        : <img crossOrigin="anonymous" src={plus} style={{ width: "50px", height: "50px" }} />
                                }
                            </div>
                        </label>
                        <input
                            accept={props.accept != undefined && props.accept != null ? props.accept : ""}
                            id={label}
                            type="file"
                            style={{ display: "none" }}
                            onChange={(e) => props.click(e.target.files[0])} />
                    </div>
            }
        </>
    )
} 